import { InvalidateQcTestResultDto, QcTestResultDto } from './dtos'
import { BaseCrudService } from './BaseCrudService'
import { axios } from './api'

const endpoint = 'qc-test-result'
const baseUrl = process.env.REACT_APP_RADIOPHARMACY_API_URL

class QcTestResultService extends BaseCrudService<never, never, never, never> {
  constructor() {
    super(endpoint, baseUrl)
  }

  invalidate(id: string, dto: InvalidateQcTestResultDto): Promise<QcTestResultDto> {
    return new Promise((resolve, reject) => {
      const configs = this.buildConfig('patch', `${this.endpoint}/${id}/invalidate`, dto)
      axios(configs, resolve, reject)
    })
  }
}

export const qcTestResultService = new QcTestResultService()
